__webpack_require__.p = "/accounterbook_app/";